<h2 mat-dialog-title>
  {{ "operations.image_crop_and_adjust" | transloco }}
</h2>
<mat-dialog-content>
  @if (loading) {
    <mat-progress-bar
      class="mat-elevation-z6"
      mode="indeterminate"
      [color]="'accent'"
    ></mat-progress-bar>
  }
  <div>
    <image-cropper
      alignImage="center"
      cropperMinWidth="256"
      format="png"
      resizeToWidth="256"
      style="max-height: 400px"
      [aspectRatio]="1"
      [hideResizeSquares]="isHandset$ | async"
      [imageBase64]="srcImage"
      [onlyScaleDown]="true"
      [roundCropper]="true"
      [transform]="imageTransform"
      (imageCropped)="imageCropped($event)"
      (cropperReady)="loading = false"
      >
    </image-cropper>
  </div>
  @if (!loading) {
    <div class="text-center">
      <mat-slider min="1" max="10" step="2" (change)="zoomChange($event)"
        ><input matSliderThumb [value]="1"
      /></mat-slider>
    </div>
  }
</mat-dialog-content>
@if (!loading) {
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ "operations.cancel" | transloco }}
    </button>
    <button mat-button color="primary" [mat-dialog-close]="true" (click)="save()">
      {{ "operations.save" | transloco }}
    </button>
  </mat-dialog-actions>
}
